// extracted by mini-css-extract-plugin
module.exports = {"text":"_93444fe79c--text--YGOr7"};